import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getPaths(context) {
      let response = await Vue.axios.get(
        `${URL_API}architecture/getbytype?architecture_type_id=9`
      );
      let data = response["data"];
      context.commit("updatePaths", data);
      return data;
    }
  },
  mutations: {
    updatePaths(state, data) {
      state.paths = data;
    }
  },
  state: {
    paths: {}
  },
  getters: {
    allPaths(state) {
      return state.paths;
    }
  }
};
